export default __webpack_public_path__ + "static/media/wTop_2_p2.509a2c09.jpeg";